import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloorPlan } from 'src/app/core/shared/interface';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-floor-plan-form',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, InputTextareaModule, ButtonModule, CheckboxModule,  DropdownModule, ToastModule,],
  templateUrl: './floor-plan-form.component.html',
  styleUrls: ['./floor-plan-form.component.scss'],
})
export class FloorPlanFormComponent implements OnChanges {
  @Input() floorPlan: FloorPlan = {} as FloorPlan;
  @Output() save = new EventEmitter<FormData>();
  imagePreviewUrl: string = '';
  selectedImage: any;
  bedOptions = Array.from({ length: 10 }, (_, i) => i + 1); // 1-10
  bathOptions = Array.from({ length: 10 }, (_, i) => i + 1); // 1-10
  editingBeds = false;
  editingBaths = false;
  bedsSelect: string = '';
  bathsSelect: string = '';
  bedOptionsDropdown = [
    { label: 'Select Beds', value: '' },
    { label: 'Studio', value: 'Studio' },
    ...this.bedOptions.map(n => ({ label: n, value: n })),
    { label: 'Other', value: 'Other' },
  ];
  bathOptionsDropdown = [
    { label: 'Select Baths', value: '' },
    { label: 'Studio', value: 'Studio' },
    ...this.bathOptions.map(n => ({ label: n, value: n })),
    { label: 'Other', value: 'Other' },
  ];
  bedOtherValue: number = 0;
  bathOtherValue: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['floorPlan'] && changes['floorPlan'].currentValue) {
      const fp = changes['floorPlan'].currentValue;
      console.log('fp', fp)
      this.selectedImage = changes['floorPlan'].currentValue.image;
      this.imagePreviewUrl = this.selectedImage;

      this.editingBeds = false;
      if (fp.beds === 0) {
        this.bedsSelect = 'Studio';
      } else if (fp.beds >= 1) {
        if(fp.beds <= 10 && Number.isInteger(fp.beds)){
          this.bedsSelect = fp.beds;
        }else{
          this.bedOtherValue = fp.beds;
          this.bedsSelect = 'Other';
          this.editingBeds = true;
        }
      } else if (fp.beds > 10) {
        this.bedOtherValue = fp.beds;
        this.bedsSelect = 'Other';
        this.editingBeds = true;
      } else {
        this.bedsSelect = '';
      }

      this.editingBaths = false;
      if (fp.baths === 0) {
        this.bathsSelect = 'Studio';
      } else if(fp.baths >= 1) {
        if(fp.baths <= 10 && Number.isInteger(fp.baths)){
          this.bathsSelect = fp.baths;
        }else{
          this.bathOtherValue = fp.baths;
          this.bathsSelect = 'Other';
          this.editingBaths = true;
        }
      } else if (fp.baths > 10) {
        this.bathOtherValue = fp.baths;
        this.bathsSelect = 'Other';
        this.editingBaths = true;
      } else {
        this.bathsSelect = '';
      }
    }
  }

  isFloorPlanValid(): boolean {
    // Validate beds
    const bedsValid = 
      this.floorPlan.beds !== null &&
      this.floorPlan.beds !== undefined &&
      this.floorPlan.beds !== -1 &&
      !(this.editingBeds && this.floorPlan.beds === null);

    // Validate baths
    const bathsValid =
      this.floorPlan.baths !== null &&
      this.floorPlan.baths !== undefined &&
      this.floorPlan.baths !== -1 &&
      !(this.editingBaths && this.floorPlan.baths === null);

    // Other required fields
    console.log('Validation Status:', this.floorPlan);
    const unitValid = this.floorPlan?.unit ? this.floorPlan.unit?.trim() !== '' : false;
    const minPriceValid = this.floorPlan.min_price != null && Number(this.floorPlan.min_price) > 0;
    const maxPriceValid = this.floorPlan.max_price != null && Number(this.floorPlan.max_price) > 0;
    const sqFtValid = this.floorPlan.sq_ft != null && Number(this.floorPlan.sq_ft) > 0;
    const maxSqFtValid = this.floorPlan.max_sq_ft != null && Number(this.floorPlan.max_sq_ft) > 0;
    // const descriptionValid = this.floorPlan.description ? this.floorPlan.description?.trim() !== '' : false;
    // console.log('Description Valid:', descriptionValid);

    // Combine all validations
    console.log((
      bedsValid &&
      bathsValid &&
      unitValid &&
      minPriceValid &&
      maxPriceValid &&
      sqFtValid &&
      maxSqFtValid 
      // && descriptionValid
    ))
    return (
      bedsValid &&
      bathsValid &&
      unitValid &&
      minPriceValid &&
      maxPriceValid &&
      sqFtValid &&
      maxSqFtValid 
      // && descriptionValid
    );
  }


  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedImage = input.files[0];
      this.imagePreviewUrl = URL.createObjectURL(this.selectedImage);
      this.floorPlan['image_title'] = this.selectedImage?.name
    }
  }

  onSubmit(form: any): void {
    if (form.valid) {
      const payload = new FormData();
      payload.append('floorPlan', JSON.stringify(this.floorPlan));
      if (this.selectedImage) {
        payload.append('image', this.selectedImage);
      }
      this.save.emit(payload);
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('image') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  removeImage() {
    this.selectedImage = null;
    this.floorPlan['image_title'] = '';
    this.floorPlan['image'] = null;
    this.imagePreviewUrl = '';
  }
  
  allowOnlyIntegers(field: 'beds' | 'baths', event: Event) {
    const input = event.target as HTMLInputElement;

    // Remove any non-digit characters
    input.value = input.value.replace(/[^0-9]/g, '');

    // Update only the specific field
    this.floorPlan[field] = input.value ? Number(input.value) : 0;
  }

  validateNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart || 0; // save cursor position

    // Keep only digits and dot
    let value = input.value
      .replace(/[^0-9.]/g, '')         // keep only digits and dots
      .replace(/(\..*?)\./g, '$1');    // keep only first dot

    // Allow only one decimal point
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }

    if (parts.length === 2 && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
      value = parts.join('.');
    }

    // Only update if value actually changes
    if (value !== input.value) {
      input.value = value;

      // Restore cursor position near original place
      const newPos = Math.min(start, value.length);
      input.setSelectionRange(newPos, newPos);
    }
  }

  validateMinMax(type='') {
    if(type == "sqft"){
      const min = this.floorPlan.sq_ft;
      const max = this.floorPlan.max_sq_ft;
      if (min != null && max != null && max < min) {
        this.floorPlan.max_sq_ft = min; // Replace with min
      }
    }
    else{
      const min = this.floorPlan.min_price;
      const max = this.floorPlan.max_price;
      if (min != null && max != null && max < min) {
        this.floorPlan.max_price = min; // Replace with min
      }
    }
  }

  allowDecimalNumbers(field: 'beds' | 'baths', event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');
    if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');

    if (parts[1]) {
      parts[1] = parts[1].slice(0, 1);
      if (parts[1] !== '0' && parts[1] !== '5') {
        parts[1] = '';
      }
      value = parts[0] + (parts[1] ? '.' + parts[1] : '');
    }

    if (Number(value) >= 100) value = '99';
    if (Number(value) < 0.5) value = '0.5';

    this.floorPlan[field] = value ? Number(value) : 0;
    input.value = value;
  }

  onSelectOther(type: 'beds' | 'baths') {
    if (type === 'beds') {
      if(this.bedsSelect == ''){
        this.floorPlan.beds = -1;
        this.editingBeds = false;
      }else{
        if (this.bedsSelect === 'Other') {
          this.floorPlan.beds = this.bedOtherValue;
          this.editingBeds = true;
        } 
        else if (this.bedsSelect === 'Studio') {
          this.floorPlan.beds = 0;
          this.editingBeds = false;
        } else {
          this.floorPlan.beds = Number(this.bedsSelect);
          this.editingBeds = false;
        }
      }

    }

    if (type === 'baths') {
      if(this.bathsSelect == ''){
        this.floorPlan.baths = -1;
        this.editingBaths = false;
      }else{
        if (this.bathsSelect === 'Other') {
          this.floorPlan.baths = this.bathOtherValue;
          this.editingBaths = true;
        }
        else if (this.bedsSelect === 'Studio') {
          this.floorPlan.baths = 0;
          this.editingBaths = false;
        } else {
          this.floorPlan.baths = Number(this.bathsSelect);
          this.editingBaths = false;
        }
      }
    }
  }

  // Stop editing when admin leaves input
  stopEditing(type: 'beds' | 'baths') {
    if (type === 'beds') this.editingBeds = false;
    if (type === 'baths') this.editingBaths = false;
  }
}
